<template>
    <div v-if="essay.audio_preview">

        <div class="h5">
            Áudio

            <span v-b-tooltip.hover title="Aqui está um comentário em áudio sobre o texto corrigido pelo professor">
                <i class="fas fa-xs fa-info-circle"></i>
            </span>
        </div>

        <b-card v-if="essay" class="mb-3">

            <audio class="audio" preload="auto" controls>
                <source :src="essay.audio_preview" />
            </audio>

        </b-card>

    </div>
</template>

<script>
export default {
    props: ['essay']
}
</script>

<style scoped>
    .audio {
        width: 100%;
    }
</style>
